import React from "react";
import axios from "axios";
import { connect } from "react-redux";
import { userActions } from "../../redux/_actions";
import { Navigate } from "react-router-dom";
import severUrl from "../../api";
import searchIcon from "../../assets/images/searchbtn.png"
import closeIcon from "../../assets/images/close.png"
import { useNavigate } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import PropTypes from "prop-types";


class MobileSearchInput extends React.Component {
  // updateInputValue(evt) {
  //   const val = evt.target.value;
  //   // ...
  //   this.setState({
  //     inputValue: val
  //   });
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props, context) {
     super(props);
  }

  state = {
    inputKey: '',
  }

  _handleKeyPress(e) {

    console.log("pressed");
    if (e.key === "Enter") {
      // localStorage.removeItem("keySearch");
      // localStorage.removeItem("search_list");
      localStorage.setItem("keySearch", e.target.value);
      console.log("key search");
      var bodyFormData = new FormData();
      bodyFormData.append("key", e.target.value);
      axios
        .post(severUrl + "blog/search", bodyFormData)
        // .then((response) => {
        //   console.log(response.json());
        //   localStorage.setItem("search_list", response.data);
        //   window.location.reload();
        // })
        .then((response) => response.data)
        .then((data) => {
          console.log(data.post)
          console.log("searching.......")
          localStorage.setItem("search_list", JSON.stringify(data.post));
          // this.props.history.push('/search')

          window.location.replace('/search');

          // window.location.replace('/search');
         
          // window.location.reload();
          
        }).catch((e) => {

          window.location.replace('/search');
          // oh no, the fetch failed! We should do something about it!
          // window.location.reload();
        });
        // window.location.replace('/search');
    }
   
  }

  handleValue(value)
  {
    this.setState({inputKey: value})
  }

  render() {
    const { searchResult, custom_style } = this.props;
    return (
      <div  style={{marginLeft:"10px", marginRight:"10px", height:"100%", alignItems:"center"}}>
      <input
        type="search"
        placeholder="Search"
        className="search-input"
        value={this.state.inputKey}
        style={{
                border: "solid 1px grey",
                borderRadius: "5px",
                // borderLeft:"none",
                // borderRight:"none",
                // borderTopRightRadius:"0",
                // borderBottomRightRadius:"0",
                marginTop:"5px",
                width:"100%",
                alignItems: "start",
                height: "30px",
                backgroundImage: 'url(' + require('../../assets/images/search.png') + ')',
                backgroundPosition: 'left',
                backgroundSize: '20px',
                backgroundRepeat: 'no-repeat',
                backgroundPositionX:"5px",
                paddingLeft:"30px",
                // position:"absolute"
              }
        }
        onChange={(e)=> this.handleValue(e.target.value)}
        onKeyPress={(e) => this._handleKeyPress(e)}
      />

        
      </div>
      // <form onsubmit="event.preventDefault();" role="search" 
      //   style={{  position: "relative",
      //     width: "95%",
      //     background: "transparent",
      //     borderRadius: "var(--rad)",
      //     padding:"0px",
      //   }}
      // >
      //   <input
      //   style={{
      //     height:"36px",
      //     margin:"10px",
      //     outline: 0,
      //     width: "100%",
      //     background: "var(--color-light)",
      //     padding: "0 1.6rem",
      //     borderRadius: "var(--rad)",
      //     borderColor:"transparent",
      //     appearance: "none", 
      //     transition: "all var(--dur) var(--bez)",
      //     transitionProperty: "width, border-radius",
      //     zIndex: 1,
      //     position: "relative"
      //   }}
      //   id="search" type="search" placeholder="Search..." autofocus required />
      // </form>
    );
  }
}

function mapState(state) {
  const { searchResult } = state.searchResult;
  return { searchResult };
}

const actionCreators = {
  search: userActions.search,
};

// const connectedSearchInput = connect(mapState, actionCreators)(SearchInput);
// export withRouter({ connectedSearchInput as SearchInput };)
export default MobileSearchInput;


